import React, { useState, useEffect } from 'react'
import { Smartphone } from 'lucide-react'
import AutoRotateIcon from './AutoRotateIcon'
import {
    loadCameraOrientation,
    loadOrientationMode,
    setManualOrientation,
    enableAutoOrientation,
    ORIENTATION_EVENT,
    AUTO_ORIENTATION_HINT,
} from './cameraConfig'
import styles from './OrientationToggle.module.css'

// Phone-camera orientation control shared by play mode (/vision) and code mode
// (Execute). Three states: Auto (follows the phone's real rotation), Landscape,
// Portrait. Picking a side pins it manually; Auto resumes following. Positioning
// is left to the parent via `className`.
const OrientationToggle = ({ className = '' }) => {
    const [orientation, setOrientation] = useState(loadCameraOrientation)
    const [mode, setMode] = useState(loadOrientationMode)

    useEffect(() => {
        const sync = () => {
            setOrientation(loadCameraOrientation())
            setMode(loadOrientationMode())
        }
        window.addEventListener(ORIENTATION_EVENT, sync)
        return () => window.removeEventListener(ORIENTATION_EVENT, sync)
    }, [])

    const pin = (o) => {
        setManualOrientation(o)
        setOrientation(o)
        setMode('manual')
    }
    const auto = () => {
        enableAutoOrientation()
        setMode('auto')
    }

    const cls = (on) => `${styles.btn} ${on ? styles.btnOn : ''}`

    return (
        <div className={`${styles.wrap} ${className}`}>
            <div className={styles.toggle}>
                <button
                    type="button"
                    className={cls(mode === 'auto')}
                    onClick={auto}
                    title="Auto (follow phone rotation)"
                    aria-label="Auto orientation"
                >
                    <AutoRotateIcon size={18} />
                </button>
                <button
                    type="button"
                    className={cls(mode === 'manual' && orientation === 'landscape')}
                    onClick={() => pin('landscape')}
                    title="Landscape"
                    aria-label="Landscape"
                >
                    <Smartphone size={20} style={{ transform: 'rotate(90deg)' }} />
                </button>
                <button
                    type="button"
                    className={cls(mode === 'manual' && orientation === 'portrait')}
                    onClick={() => pin('portrait')}
                    title="Portrait"
                    aria-label="Portrait"
                >
                    <Smartphone size={20} />
                </button>
            </div>
            {mode === 'auto' && (
                <p className={styles.hint}>{AUTO_ORIENTATION_HINT}</p>
            )}
        </div>
    )
}

export default OrientationToggle
